import { render, staticRenderFns } from "./BiodataForm.vue?vue&type=template&id=1473b824&scoped=true&"
import script from "./BiodataForm.vue?vue&type=script&lang=js&"
export * from "./BiodataForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1473b824",
  null
  
)

export default component.exports